import {
    UniformSlot,
    UniformSlotWrapperComponentProps
} from "@uniformdev/canvas-react";

import { GenericTableCustomCell } from "@/libraries/design/patterns/table/src/generic-table-custom-cell.tsx";

const fragmentWrapper = ({ items }: UniformSlotWrapperComponentProps) => (
    <>{items}</>
);

const UniformCustomTableCell = () => {
    return (
        <GenericTableCustomCell>
            <UniformSlot name="contents" wrapperComponent={fragmentWrapper} />
        </GenericTableCustomCell>
    );
};

export default UniformCustomTableCell;
